export const GET_REF_BIKE_MODEL_REQUEST = 'GET_REF_BIKE_MODEL_REQUEST';
export const GET_REF_BIKE_MODEL_REQUEST_SUCCESS = 'GET_REF_BIKE_MODEL_REQUEST_SUCCESS';
export const GET_REF_BIKE_MODEL_REQUEST_FAILURE = 'GET_REF_BIKE_MODEL_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_ref_bike_model.constants.js